import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { uploadFile } from "@/lib/compress";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Field } from "@/components/common";

const FIELDS = [["name", "Company Name"], ["gstin", "GSTIN"], ["pan", "PAN"], ["phone", "Phone"], ["email", "Email"], ["address", "Address"], ["city", "City"], ["state", "State"],
  ["bank_name", "Bank Name"], ["bank_account", "Bank Account No"], ["bank_ifsc", "IFSC Code"], ["bank_branch", "Bank Branch"]];

export default function CompanySettings() {
  const { refreshMe } = useAuth();
  const [f, setF] = useState(null);
  const [logo, setLogo] = useState(null);
  useEffect(() => { api.get("/company").then((r) => setF(r.data)); }, []);
  useEffect(() => {
    if (!f?.logo_file_id) { setLogo(null); return; }
    api.get(`/files/${f.logo_file_id}`, { responseType: "blob" }).then((r) => setLogo(URL.createObjectURL(r.data))).catch(() => setLogo(null));
  }, [f?.logo_file_id]);
  if (!f) return null;
  const uploadLogo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try { const { data } = await uploadFile("/uploads?ref_type=document", file); setF({ ...f, logo_file_id: data.id }); toast.success("Logo uploaded — Save Profile dabayein"); } catch (err) { toast.error(errMsg(err)); }
  };
  const save = async () => {
    try {
      await api.put("/company", { ...Object.fromEntries(FIELDS.map(([k]) => [k, f[k] || ""])), logo_file_id: f.logo_file_id || "" });
      toast.success("Company profile saved");
      refreshMe();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="Company Profile" subtitle="Shown on Lorry Receipts and GST invoices" />
      <div className="card-base p-6 fade-up">
        <div className="mb-5 flex items-center gap-4" data-testid="company-logo-section">
          <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-lg border bg-secondary">
            {logo ? <img src={logo} alt="Company logo" className="h-full w-full object-contain" data-testid="company-logo-preview" /> : <span className="text-[10px] text-muted-foreground">No logo</span>}
          </div>
          <label className="cursor-pointer rounded-md border px-3 py-2 text-xs font-semibold hover:bg-accent">
            Upload Logo
            <input type="file" accept="image/*" className="hidden" data-testid="company-logo-input" onChange={uploadLogo} />
          </label>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <Field key={k} label={l} className={k === "address" ? "sm:col-span-2" : ""}>
              <Input data-testid={`company-${k}-input`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
            </Field>
          ))}
        </div>
        <Button data-testid="company-save-btn" className="mt-6" onClick={save}>Save Profile</Button>
      </div>
      <RecalcCard />
    </div>
  );
}

function RecalcCard() {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const run = async () => {
    if (!window.confirm("Purani trips ko naye niyam se dobara hisaab karein? (Toll, Per-KM diesel, driver allowance) — Settled trips nahi badlengi.")) return;
    setBusy(true);
    try { const { data } = await api.post("/recalculate-old-data"); setRes(data); toast.success("Purana data update ho gaya"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-base mt-6 p-6 fade-up" data-testid="recalc-card">
      <h2 className="text-base font-semibold">Purana Data Naye Niyam Se Update Karein</h2>
      <p className="mt-1 text-sm text-muted-foreground">FASTag toll ko trip ki Loading–Delivery tarikh se jodta hai (jo gaadi baad me Fleet me jodi gayi unke toll bhi), Per-KM gaadi ka diesel driver khate me daalta hai, aur unsettled trips ka driver KM allowance dobara banata hai. Bank me "Vehicle EMI" category se reconcile ki gayi entries us gaadi ke loan me Paid ho jaati hain, aur Party Booking me badli gayi party uski LR me bhi lag jaati hai. Party Master ki nayi details (GSTIN, pata, phone) purani LR aur Bill me bhi bhar jaati hain.</p>
      <Button data-testid="recalc-btn" className="mt-4" variant="secondary" disabled={busy} onClick={run}>{busy ? "Update ho raha hai…" : "Recalculate Old Data"}</Button>
      {res && <p className="mt-3 text-sm" data-testid="recalc-result">Toll gaadi se jude: <b>{res.tolls_matched}</b> · Per-KM diesel driver khate me: <b>{res.perkm_diesel_moved}</b> · Allowance update: <b>{res.allowance_updated}</b> · Vehicle EMI loan me: <b>{res.emi_to_loan}</b> · LR party theek: <b>{res.lr_party_fixed}</b> · Party details LR/Bill me: <b>{res.party_details_updated}</b></p>}
    </div>
  );
}
